import React from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

//import avatar1 from "https://servidorpruebapp.itnmexico.com/archivos/usuarios/rodolfo-espinosa.jpg"
import profileImg from "../../assets/images/profile-img.png"
import novaImg from "../../assets/images/nova.jpg"

const WelcomeComp = (props) => { 
  const paraWelcome = props.paraWelcome;
  const listaLiberaciones = props.listaLiberaciones;
  const tareasPendientes = props.tareasPendientes;
  console.log("listaliberaciones:"+listaLiberaciones)
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Bienvenido!</h5>
                <p>Dashboard de {paraWelcome.nombre}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src="https://servidorpruebapp.itnmexico.com/archivos/proyectos/Up-Santa-Fe.jpeg" alt="Proyecto" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src="https://servidorpruebapp.itnmexico.com/archivos/usuarios/rodolfo-espinosa.jpg"
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-truncate">{paraWelcome.manager}</h5>
              <p className="text-muted mb-0 text-truncate">Project Manager</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">{listaLiberaciones.length}</h5>
                    <p className="text-muted mb-0">Inspecciones realizadas</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">{tareasPendientes.length}</h5>
                    <p className="text-muted mb-0">Tareas Pendientes</p>
                  </Col>
                </Row>
                {/** 
                <div className="mt-4">
                  <Link
                    to=""
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
                */}
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
